import type { ConsentManagementTool } from '../model';
import type { ConsentManagementPostAttributes } from './types';

const mapConsentManagementToolToApiAttributes = (tool: ConsentManagementTool | null): ConsentManagementPostAttributes => {
  switch (tool) {
    case null:
      return { gdpr: false, cmp: null };
    case 'CookieInformationCMP':
      return { gdpr: true, gdprUserModeEnabled: true, cmp: 'cookie_information' };
    case 'PiwikLegacy':
      return { gdpr: true, gdprUserModeEnabled: false, cmp: 'piwik' };
    case 'OtherConsentTool':
      return { gdpr: true, gdprUserModeEnabled: true, cmp: null };
    default:
      throw new Error(`Unexpected consent management tool "${tool}"`);
  }
};

export { mapConsentManagementToolToApiAttributes };
